import VueRouter from "vue-router";

import Home from '../page/Home/my_index.vue'
import Sort from '../page/Sort/my_sort.vue'
import My from '../page/My/my_own.vue'
import Shop_type from '../src/components/shop_type.vue'
import Shop_info from '../src/components/shop_info.vue'
import My_login from '../src/components/my_login.vue'
import User_info from '../src/components/user_info.vue'
import My_address from '../src/components/my_address.vue'
import Add_address from '../src/components/add_address.vue'
import Order_list from '../src/components/order_list.vue'
import Aaaa from '../src/components/my_goods.vue'

const router = new VueRouter({
    base: '/mobile/',
    routes: [
        {
            path: '/',
            redirect: '/home',
            meta: { title: '首页' }
        },
        {
            path: '/home',
            name: 'Home',
            component: Home,
            meta: { title: '首页' }
        },
        {
            path: '/sort',
            component: Sort,
            meta: { title: '分类' }
        },
        {
            path: '/my',
            component: My,
            meta: { title: '我的' }
        },
        {
            path: '/shop_type',
            component: Shop_type,
            meta: { title: '商品列表' }
        },
        {
            path: '/shop_info',
            component: Shop_info,
            meta: { title: '商品详情'}   // 默认不缓存   是否从地址页面返回
        },
        {
            path: '/login',
            component: My_login,
            name: 'Login',
            meta: { title: '登录', guestOnly: true }  //仅未登录用户可以访问
        },
        {
            path: '/user_info',
            component: User_info,
            meta: { title: '完善信息', requiresAuth: true }
        },
        {
            path: '/address',
            component: My_address,
            meta: { title: '收货地址', requiresAuth: true }
        },
        {
            path: '/add_address',
            component: Add_address,
            meta: { title: '新增地址', requiresAuth: true }
        },
        {
            path: '/order_list',
            component: Order_list,
            meta: { title: '我的订单', requiresAuth: true }
        },
        {
            path: '/aaaa',
            component: Aaaa,
            meta: { title: '哈哈', requiresAuth: true, }
        }
    ]
})
// 全局前置守卫
router.beforeEach((to, from, next) => {
    const isLoggedIn = checkAuthStatus() // 检查用户是否登录（如检查 localStorage 或 Vuex）
    // 如果目标路由需要登录，但用户未登录
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!isLoggedIn) {
            next({ name: 'Login', query: { redirect: to.fullPath } }) // 跳转登录页，并记录原目标路径
        } else {
            next() // 已登录，放行
        }
    } else if (to.matched.some(record => record.meta.guestOnly)) {
        if (isLoggedIn) {
            next({ name: 'Home' }) // 如果已登录，则跳转到首页（避免重复登录）
        } else {
            next() // 未登录，允许访问
        }
    } else {
        next()  //其他情况 放行
    }
    document.title = to.meta.title || '默认标题'

})
function checkAuthStatus() {
    return localStorage.getItem('auth_token') !== null
}
export default router